import type { AssetKind } from "./schemas";

const paths = { image: "images", video: "videos", audio: "audio", basemap: "basemaps" } as const;

/** The readable kind in an asset's public page URL. */
export const assetKindPath = (kind: AssetKind) => paths[kind];

export function assetKindFromPath(path: string): AssetKind | undefined {
  return (Object.entries(paths) as [AssetKind, string][]).find(([, value]) => value === path)?.[0];
}

export function assetPagePath(kind: AssetKind, slug: string): string {
  return `/assets/${assetKindPath(kind)}/${slug}`;
}
